/**
 * Extraction Constants
 */
export const EXTRACTION_TIMEOUT_MILLIS = 30 * 1000;

/**
 * UI layout Constants
 */
export const MAX_DEVICE_NAME_WIDTH = 160;

/**
 * Network request Constants
 */
// ################################### App name ###################################
export const STK_APP_NAME_QUICK_SEND = "chrome_ocs";
export const STK_APP_NAME_PREVIEW_SEND = "chrome_preview";

// ################################### Epub ###################################
export const EPUB_HELPER = {
    METADATA_FILE_PATH: "OEBPS/content.opf",
    HTML_CONTENT_PATH: "OEBPS/content.xhtml",
};

// ################################### Request status code ###################################
export const NETWORK_STATUS_CODE = {
    SUCCESS: "0",
    CANCEL: "1000",

    GENERAL_FAIL: "-1000",
    NO_NETWORK: "-1001",
    DATA_RETRIEVE_FAIL: "-1002",
    TIMEOUT: "-1003",
};

// ################################### STK File/Data type ###################################
/**
 * @enum {string}
 */
export const STK_DATA_TYPE = {
    HTML: "text/html",
    EPUB: "application/epub+zip",
};

/**
 * @enum {string}
 */
export const STK_FILE_TYPE = {
    HTML: "html",
    EPUB: "epub",
};

/**
 * Extension to Datatype mapping
 * @enum {string}
 */
export const STK_DATATYPE_EXTENSION_MAPPING = {
    "jpg": "image/jpeg",
    "jpeg": "image/jpeg",
    "png": "image/png",
    "gif": "image/gif",
    "bmp": "image/bmp",
    "tiff": "image/tiff",
    "tif": "image/tiff",
    "webp": "image/webp",
    "svg": "image/svg+xml"
};

// ################################### Strings ###################################
export const STK_STRING_UNKNOWN = "Unknown";